import React from 'react';
import { motion } from 'framer-motion';

const InstrumentPage = () => {
  // Mapping of each instrument to its specific Google Drive folder link.
  const instrumentFolders = {
    "Violin I": "https://drive.google.com/drive/folders/1Ml3YF9192Ah2D-yT8bZTqorHBJbuR62B?usp=sharing",
    "Violin II": "https://drive.google.com/drive/folders/1yeX12_QG8pK7rI4Lik2Xn8dM-XexT08M?usp=sharing",
    "Viola": "https://drive.google.com/drive/folders/1dWwiGMIXVW1svsjMCGDC1NT4J2s79NmV?usp=sharing",
    "Cello": "https://drive.google.com/drive/folders/1SMOTUVtVBqIrgdAdyxexcXK44Bxqb117?usp=sharing",
    "Bass": "https://drive.google.com/drive/folders/1c0EIIdCjayQ02f5CS8Y_HrM6eaetjJNA?usp=share_link",
    "Flute": "https://drive.google.com/drive/folders/1_e6dr6Hu_W5pBaYMp_euMVP_fic1FH41?usp=sharing",
    "Clarinet": "https://drive.google.com/drive/folders/1H50VwGSnSQYZ4Ptl35yFbZinKIrJQA8U?usp=sharing",
    "Oboe": "https://drive.google.com/drive/folders/1SUfrHfzkSgj7cPJVEW-UCZyLh7rlQ_75?usp=sharing",
    "Bassoon": "https://drive.google.com/drive/folders/1Hdk0AmBnygPeKOCqEmwJ-SJfwda3bo5F?usp=sharing",
    "Trumpet": "https://drive.google.com/drive/folders/1KJn67-D3qr7S8chOxgte0V9A8nYxL0Tx?usp=sharing",
    "Trombone": "https://drive.google.com/drive/folders/1b4L14Kd7cT028T61xlJ4FzkyP5BJ9bxM?usp=sharing",
    "Horn": "https://drive.google.com/drive/folders/1kQhgdDOx-XKvP8iaI5G_DZItOV9pDYJZ?usp=sharing",
    "Tuba": "https://drive.google.com/drive/folders/1ei7lbVjqUsw2YRl25LIOxyuzFb58RnK6?usp=sharing",
    "Percussion": "https://drive.google.com/drive/folders/1cuTKoBR074JvX3K_cqSTUGnTzf_t2Wqa?usp=sharing",
    "Harp": "https://drive.google.com/drive/folders/your_harp_folder_link?usp=share_link",
    "Piano": "https://drive.google.com/drive/folders/1iu1VTL0OumgQhAE7-NHYY1PDLLJJh_Sk?usp=sharing",
  };

  // Extract instruments as an array for mapping.
  const instruments = Object.keys(instrumentFolders);

  return (
    <div className="bg-[#101827] min-h-screen py-10">
      <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-6 text-center text-gray-900">
          Instrument Sheet Music
        </h1>
        <p className="text-gray-700 mb-8 text-center">
          Click on an instrument below to view the corresponding sheet music on Google Drive.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {instruments.map((instrument) => (
            <motion.a
              key={instrument}
              href={instrumentFolders[instrument]}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="block bg-blue-600 text-white px-4 py-3 rounded text-center transition-colors hover:bg-blue-700"
            >
              {instrument}
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstrumentPage;
